module.exports = __webpack_public_path__ + "static/media/olcatKan.39c7ddba.jpg";